import { render, staticRenderFns } from "./DemonstrativoNotas.vue?vue&type=template&id=77b7d90a&"
import script from "./DemonstrativoNotas.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports